import styled from "@emotion/styled";

interface IProps {
  active?: boolean;
  desc?: boolean;
  onClick?(): void;
}

/**
 * Column label for LightTable
 */
export const ColLabel = styled.span<IProps>`
  position: relative;
  display: inline-block;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.active ? props.theme.primaryColor80 : props.theme.primaryColor60)
  };
  cursor: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.onClick ? "pointer" : "auto")
  };
  user-select: none;
  padding-left: 18px;
  transition: padding 0.1s linear;

  &:before {
    position: absolute;
    top: 50%;
    left: 0;
    display: "inline-block";
    opacity: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => (props.active ? 1 : 0)
    };
    margin-right: 7px;
    content: " ";
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid
      ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => props.theme.primaryColor80
      };
    vertical-align: top;
    transition: transform 0.15s linear;
    transform: translateY(-50%)
      rotate(
        ${
          // FIXME: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
          (props: any) => (props.desc ? 180 : 0)
        }deg
      );
  }
`;
